import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpOptions, HttpService, UNDEFINED_TYPE } from './../../../utils';
import { assertDependency, isAssertOn } from './../../internal/assert';
import { createHttpServiceOnHttpClient } from './../../utils/http.service.on.http.client';
import { createHttpServiceOnJsonp } from './../../utils/http.service.on.jsonp';
import { assign } from './../../utils/js.utils';
import { lw } from './../logger/logger.service';
import { ZoneService } from './../zone/zone.service';


/* Copyright IBM Corp. 2017 */
// logging statement
const LOGGER = 'HttpServiceOnJsonp';

/**
 * @dynamic
 */
@Injectable({ providedIn: 'root' })
export class HttpServiceOnJsonp implements HttpService {

  // interface implementation
  getJson: <T>(aUrl: string, aOptions: HttpOptions) => Observable<T>;
  getText: (aUrl: string, aOptions: HttpOptions) => Observable<string>;

  constructor(
    @Optional() @Inject(DOCUMENT) aDocument: Document,
    aHttpClient: HttpClient,
    aZoneService: ZoneService) {
    // validate the dependencies
    if (isAssertOn()) {
      // assert our dependencies
      assertDependency(aHttpClient, 'HttpClient');
      assertDependency(aZoneService, 'ZoneService');
    }
    // get the global scope
    if (typeof window !== UNDEFINED_TYPE) {
      // validate the dependencies
      if (isAssertOn()) {
        // assert our dependencies
        assertDependency(aDocument, 'Document');
      }
      // override
      assign(this, createHttpServiceOnJsonp(aDocument, window, aZoneService));
    } else {
      // warn
      lw(LOGGER, 'Fallback to HttpClient since there is no window object.');
      // fallback to the http version
      assign(this, createHttpServiceOnHttpClient(aHttpClient));
    }
  }
}
